export default {
  sectionTitle: {
    id: 'buyback_search_section_title',
    defaultMessage:
      'From pristine to non-functional, get the top offer from 250+ refurbishers.',
  },
}
